module.exports = __webpack_public_path__ + "img/Perks-Gift-40.c6612661.png";